<template>
	<div class="" style="padding-top: 4rem">
		<div class="card-body" style="background: #fff">
			<legend>Annual Report Details:</legend>
			<div class="row">
				<div class="col-md-6">
					<div class="row mb-3">
						<label for="report_from" class="col-sm-4 col-form-label"
							>Report Period From:</label
						>
						<div class="col-sm-8">
							<input
								:value="form.period_from_formatted"
								name="report_from"
								id="report_from"
								type="text"
								class="form-control"
								disabled
							/>
						</div>
					</div>
				</div>
				<div class="col-md-6">
					<div class="row mb-3">
						<label for="report_to" class="col-sm-4 col-form-label"
							>Report Period To:</label
						>
						<div class="col-sm-8">
							<input
								:value="form.period_to_formatted"
								name="report_to"
								id="report_to"
								type="text"
								class="form-control"
								disabled
							/>
						</div>
					</div>
				</div>
				<div class="col-md-6">
					<div class="row mb-3">
						<label for="approval_document" class="col-sm-4 col-form-label"
							>Approval Document:</label
						>
						<div class="col-sm-8">
							<a
								:href="form.approval_document"
								target="_blank"
								class="btn btn-link form-control"
								>View Document</a
							>
						</div>
					</div>
				</div>
				<div class="col-md-6">
					<div class="row mb-3">
						<label for="approved_by" class="col-sm-4 col-form-label"
							>Approved By:</label
						>
						<div class="col-sm-8">
							<input
								:value="form.approved_by"
								name="approved_by"
								id="approved_by"
								type="text"
								class="form-control"
								disabled
							/>
						</div>
					</div>
				</div>
				<div class="col-md-6">
					<div class="row mb-3">
						<label for="audited_by" class="col-sm-4 col-form-label"
							>Audited By:</label
						>
						<div class="col-sm-8">
							<input
								:value="form.audited_by"
								name="audited_by"
								id="audited_by"
								type="text"
								class="form-control"
								disabled
							/>
						</div>
					</div>
				</div>
				<div class="col-md-6">
					<div class="row mb-3">
						<label for="party" class="col-sm-4 col-form-label"
							>Political Party:</label
						>
						<div class="col-sm-8">
							<input
								:value="form.party.abbreviation"
								name="party"
								id="party"
								type="text"
								class="form-control"
								disabled
							/>
						</div>
					</div>
				</div>

				<div class="col-md-6">
					<div class="row mb-3">
						<label for="submitted_by" class="col-sm-4 col-form-label"
							>Report Submitted By:</label
						>
						<div class="col-sm-8">
							<input
								:value="`${form.created_by.name} - (${form.created_by.state.name})`"
								name="submitted_by"
								id="submitted_by"
								type="text"
								class="form-control"
								disabled
							/>
						</div>
					</div>
				</div>
				<div class="col-md-6">
					<div class="row mb-3">
						<label for="audited_by" class="col-sm-4 col-form-label"
							>Audited By:</label
						>
						<div class="col-sm-8">
							<input
								:value="form.audited_by"
								name="audited_by"
								id="audited_by"
								type="text"
								class="form-control"
								disabled
							/>
						</div>
					</div>
				</div>
				<div class="col-md-6">
					<div class="row mb-3">
						<label for="accountant_name" class="col-sm-4 col-form-label"
							>Accountant Name:</label
						>
						<div class="col-sm-8">
							<input
								:value="form.accountant_name"
								name="accountant_name"
								id="accountant_name"
								type="text"
								class="form-control"
								disabled
							/>
						</div>
					</div>
				</div>
				<div class="col-md-6">
					<div class="row mb-3">
						<label for="created_at" class="col-sm-4 col-form-label"
							>Date Submitted:</label
						>
						<div class="col-sm-8">
							<input
								:value="form.created_at"
								name="created_at"
								id="created_at"
								type="text"
								class="form-control"
								disabled
							/>
						</div>
					</div>
				</div>
			</div>
			<div v-if="form.is_owner" align="right">
				<a
					href="#"
					@click.prevent="showEditForm = true"
					class="btn btn-secondary"
					>Edit</a
				>
			</div>
		</div>
		<!-- Amount Received -->
		<div class="card-body mt" style="background: #fff">
			<fieldset class="dt-responsive table-responsive">
				<legend>Amount Received:</legend>

				<table id="dt-live-domd" class="table table-bordered nowrap">
					<thead>
						<tr>
							<!-- <th>NO</th> -->
							<th style="width: 10%; text-wrap-mode: wrap">Type</th>
							<th v-for="month in months" :key="'th_' + month.name">
								{{ month.value }}
							</th>
							<th v-if="form.is_owner" class="text-center">Action</th>
						</tr>
					</thead>
					<tbody>
						<template v-if="Object.keys(form.incomes).length">
							<tr v-for="type in amount_types" :key="'tm_' + type.name">
								<template v-if="form.incomes[type.name]">
									<td>
										{{ type.value }}
									</td>
									<td v-for="month in months" :key="'tm_' + month.name">
										{{
											form.incomes[type.name][month.name]
												? form.incomes[type.name][month.name][0].total_amount
												: "0.00"
										}}
									</td>
									<td v-if="form.is_owner" style="padding: 0.1rem">
										<button
											@click="
												deleteItem(
													Object.values(form.incomes[type.name])[0][0],
													'amount_received'
												)
											"
											class="btn btn-danger"
											style="width: fit-content"
											:disable="isLoading"
										>
											<span
												v-if="isLoading"
												class="spinner-border spinner-border-sm"
												role="status"
											></span>
											<span v-else class="pcoded-micon"
												><i
													class="feather icon-trash"
													style="font-size: 18px"
													title="Delete item"
												></i
											></span>
										</button>
									</td>
								</template>
							</tr>
						</template>
					</tbody>
				</table>
			</fieldset>
		</div>
		<!-- Amount Received Ends -->

		<!-- Amount Expended -->
		<div class="card-body mt" style="background: #fff">
			<fieldset class="dt-responsive table-responsive">
				<legend>Amount Expended:</legend>

				<table id="dt-live-domd" class="table table-bordered nowrap">
					<thead>
						<tr>
							<!-- <th>NO</th> -->
							<th style="width: 10%; text-wrap-mode: wrap">Type</th>
							<th v-for="month in months" :key="'th_' + month.name">
								{{ month.value }}
							</th>
							<th v-if="form.is_owner" class="text-center">Action</th>
						</tr>
					</thead>
					<tbody>
						<template v-if="Object.keys(form.expenses).length">
							<tr v-for="type in expenditure_types" :key="'tm_' + type.name">
								<template v-if="form.expenses[type.name]">
									<td>
										{{ type.value }}
									</td>
									<td v-for="month in months" :key="'tm_' + month.name">
										{{
											form.expenses[type.name][month.name]
												? form.expenses[type.name][month.name][0].total_amount
												: "0.00"
										}}
									</td>
									<td v-if="form.is_owner" style="padding: 0.1rem">
										<button
											@click="
												deleteItem(
													Object.values(form.expenses[type.name])[0][0],
													'amount_expended'
												)
											"
											class="btn btn-danger"
											style="width: fit-content"
											:disable="isLoading"
										>
											<span
												v-if="isLoading"
												class="spinner-border spinner-border-sm"
												role="status"
											></span>
											<span v-else class="pcoded-micon"
												><i
													class="feather icon-trash"
													style="font-size: 18px"
													title="Delete item"
												></i
											></span>
										</button>
									</td>
								</template>
							</tr>
						</template>
					</tbody>
				</table>
			</fieldset>
		</div>
		<!-- Amount Expended Ends-->

		<!-- Donations Starts-->
		<div class="card-body mt" style="background: #fff">
			<fieldset class="dt-responsive table-responsive">
				<legend>Contributions & Donations:</legend>

				<table id="dt-live-domd" class="table table-bordered nowrap">
					<thead>
						<tr>
							<th>Name</th>
							<th>Address</th>
							<th>Occupation</th>
							<th>Type of <br />Contributor <br />(cash/in kind)</th>
							<th>Description of Contribution</th>
							<th>Value</th>
							<th>Total</th>
							<th v-if="form.is_owner" class="text-center">Action</th>
						</tr>
					</thead>
					<tbody>
						<template v-if="Object.keys(form.contributions).length">
							<tr
								v-for="contribution in form.contributions"
								:key="'dn_' + contribution.id"
							>
								<td style="padding: 0.1rem 0.7rem">
									{{ contribution.name }}
								</td>
								<td style="padding: 0.1rem 0.7rem">
									{{ contribution.address }}
								</td>
								<td style="padding: 0.1rem 0.7rem">
									{{ contribution.occupation }}
								</td>
								<td style="padding: 0.1rem 0.7rem">
									{{ contribution.type_of_contribution }}
								</td>
								<td style="padding: 0.1rem 0.7rem">
									{{ contribution.description }}
								</td>
								<td style="padding: 0.1rem 0.7rem">
									{{ contribution.value }}
								</td>
								<td style="padding: 0.1rem 0.7rem">
									{{ contribution.total }}
								</td>
								<td
									v-if="form.is_owner"
									class="text-center"
									style="padding: 0.1rem"
								>
									<button
										@click="deleteItem(contribution, 'contributions_donations')"
										class="btn btn-danger"
										style="width: fit-content"
										:disable="isLoading"
									>
										<span
											v-if="isLoading"
											class="spinner-border spinner-border-sm"
											role="status"
										></span>
										<span v-else class="pcoded-micon"
											><i
												class="feather icon-trash"
												style="font-size: 18px"
												title="Delete item"
											></i
										></span>
									</button>
								</td>
							</tr>
						</template>
					</tbody>
				</table>
			</fieldset>
		</div>
		<!-- Donations Ends-->

		<!-- Assets Starts-->
		<div class="card-body mt" style="background: #fff">
			<fieldset class="dt-responsive table-responsive">
				<legend>Assets:</legend>

				<table id="dt-live-domd" class="table table-bordered nowrap">
					<thead>
						<tr>
							<th>Description of Asset</th>
							<th>Location of Asset</th>
							<th>Current Asset value</th>
							<th v-if="form.is_owner" class="text-center">Action</th>
						</tr>
					</thead>
					<tbody>
						<template v-if="Object.keys(form.assets).length">
							<tr v-for="asset in form.assets" :key="'ast_' + asset.id">
								<td style="padding: 0.75rem 0.75rem">
									{{ asset.description }}
								</td>
								<td style="padding: 0.75rem 0.75rem">
									{{ asset.address }}
								</td>
								<td style="padding: 0.75rem 0.75rem">
									{{ asset.value }}
								</td>
								<td
									v-if="form.is_owner"
									class="text-center"
									style="padding: 0.1rem"
								>
									<button
										@click="deleteItem(asset, 'assets')"
										class="btn btn-danger"
										style="width: fit-content"
										:disable="isLoading"
									>
										<span
											v-if="isLoading"
											class="spinner-border spinner-border-sm"
											role="status"
										></span>
										<span v-else class="pcoded-micon"
											><i
												class="feather icon-trash"
												style="font-size: 18px"
												title="Delete item"
											></i
										></span>
									</button>
								</td>
							</tr>
						</template>
					</tbody>
				</table>
			</fieldset>
		</div>
		<!-- Assets Ends-->

		<!-- Liabilities Starts-->
		<div class="card-body mt" style="background: #fff">
			<fieldset class="dt-responsive table-responsive">
				<legend>Liabilities:</legend>

				<table id="dt-live-domd" class="table table-bordered nowrap">
					<thead>
						<tr>
							<th>Type of Liability</th>
							<th>Creditor</th>
							<th>Value</th>
							<th v-if="form.is_owner" class="text-center">Action</th>
						</tr>
					</thead>
					<tbody>
						<template v-if="Object.keys(form.liabilities).length">
							<tr
								v-for="liability in form.liabilities"
								:key="'lb_' + liability.id"
							>
								<td style="padding: 0.75rem 0.75rem">
									{{ liability.liability_type }}
								</td>
								<td style="padding: 0.75rem 0.75rem">
									{{ liability.name }}
								</td>
								<td style="padding: 0.75rem 0.75rem">
									{{ liability.value }}
								</td>
								<td
									v-if="form.is_owner"
									class="text-center"
									style="padding: 0.1rem"
								>
									<button
										@click="deleteItem(liability, 'liabilities')"
										class="btn btn-danger"
										style="width: fit-content"
										:disable="isLoading"
									>
										<span
											v-if="isLoading"
											class="spinner-border spinner-border-sm"
											role="status"
										></span>
										<span v-else class="pcoded-micon"
											><i
												class="feather icon-trash"
												style="font-size: 18px"
												title="Delete item"
											></i
										></span>
									</button>
								</td>
							</tr>
						</template>
					</tbody>
				</table>
			</fieldset>
		</div>
		<!-- Liabilities Ends-->

		<!-- Bank Details Starts-->
		<div class="card-body mt" style="background: #fff">
			<fieldset class="dt-responsive table-responsive">
				<legend>Bank Details:</legend>
				<table id="dt-live-domd" class="table table-bordered nowrap">
					<thead>
						<tr>
							<th>Name of Bank</th>
							<th>Account Type</th>
							<th>Account Name</th>
							<th>Account Number</th>
							<th>Signatories</th>
							<th v-if="form.is_owner">Action</th>
						</tr>
					</thead>
					<tbody>
						<template v-if="Object.keys(form.banks).length">
							<tr v-for="bank in form.banks" :key="'ast_' + bank.id">
								<td style="padding: 0.75rem 0.75rem">
									{{ bank.bank_name }}
								</td>
								<td style="padding: 0.75rem 0.75rem">
									{{ bank.account_type }}
								</td>
								<td style="padding: 0.75rem 0.75rem">
									{{ bank.account_name }}
								</td>
								<td style="padding: 0.75rem 0.75rem">
									{{ bank.account_number }}
								</td>
								<td style="padding: 0.75rem 0.75rem">
									{{ bank.signatories }}
								</td>
								<td v-if="form.is_owner" style="padding: 0">
									<button
										@click="deleteItem(bank, 'bank_details')"
										class="btn btn-danger"
										style="border-radius: 0; height: 47px; width: 100%"
										:disable="isLoading"
									>
										<span
											v-if="isLoading"
											class="spinner-border spinner-border-sm"
											role="status"
										></span>
										<span v-else>Delete</span>
									</button>
								</td>
							</tr>
						</template>
					</tbody>
				</table>
			</fieldset>
		</div>
		<!-- Bank Details Ends-->

		<div align="center" class="mt-5">
			<router-link
				to="/forms/annual-report"
				tag="button"
				class="btn btn-secondary btn-sm btn-round"
				>Back to List</router-link
			>
		</div>

		<!-- Edit form -->
		<EditForm v-if="showEditForm" :report="form" />
	</div>
</template>
<script>
import { months, expenditure_types } from "@/utils/helpers.js";
import { amount_types } from "@/utils/helpers.js";
import EditForm from "@/views/Forms/Annual/partials/EditForm.vue";
import { EventBus } from "@/utils/event_bus.js";
import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2";

export default {
	components: {
		EditForm,
	},
	data() {
		return {
			showEditForm: false,
		};
	},
	computed: {
		...mapGetters({
			isLoading: "shared/getLoading",
			form: "form_ec16c/singleForm",
		}),
		months() {
			return months;
		},
		expenditure_types() {
			return expenditure_types;
		},
		amount_types() {
			return amount_types;
		},
	},
	methods: {
		...mapActions({
			getFormByID: "form_ec16c/getFormByID",
			deleteFormRecord: "form_ec16c/deleteFormRecord",
		}),

		deleteItem(item, item_type) {
			Swal.fire({
				title: this.getModalTitle(item_type),
				text: "This action cannot be undone!",
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#d33",
				cancelButtonColor: "#29623c",
				confirmButtonText: "Yes, delete!",
				cancelButtonText: "Cancel",
			}).then((result) => {
				if (result.isConfirmed) {
					this.sendDeleteRequest(item);
				}
			});
		},

		async sendDeleteRequest(item) {
			let payload = {
				report_id: item.party_annual_report_id,
				item_id: item.id,
				item_type: item.item_type,
				report_type: item.report_type,
				page: "details",
			};
			await this.deleteFormRecord(payload).then((res) => {
				if (res.status_code == 200) {
					Swal.fire("Deleted!", res.data.message, "success");
				}
			});
		},

		getModalTitle(title) {
			if (title == "amount_received") {
				title = "Amount Received";
			}

			if (title == "amount_expended") {
				title = "Amount Expended";
			}

			if (title == "contributions_donations") {
				title = "Donation";
			}

			if (title == "assets") {
				title = "Asset";
			}

			if (title == "liabilities") {
				title = "Liability";
			}

			if (title == "bank_details") {
				title = "Bank Details";
			}

			return `Delete ${title.toUpperCase()}?`;
		},
	},
	mounted() {
		this.getFormByID({ formID: this.$route.params.formID });
		EventBus.$on("toggle-modal", (type) => {
			if (type == "hide") {
				this.showEditForm = false;
			}
		});
	},
};
</script>
<style scoped>
legend {
	background-color: #29623c;
	color: white;
	padding: 5px 10px;
}
.break-text {
	word-wrap: break-word;
	overflow-wrap: break-word;
	white-space: normal;
	padding: 0;
	padding-left: 2px;
	padding-top: 20px;
}
table {
	width: 100%;
	border-collapse: collapse;
}

td > input,
select {
	width: 100%;
	height: 100%;
	box-sizing: border-box;
	border: none;
	padding-top: 20px;
	padding-left: 0;
	padding-right: 0;
	border-radius: 0;
	height: 100%;
}

.mt {
	margin-top: 3rem;
}

.swal2-container {
	z-index: 1090 !important;
}

.modal {
	z-index: 1059 !important;
}
</style>
